import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articles, Article } from '../../data/articles';
import './ArticleDetail.css';

const ArticleDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [article, setArticle] = useState<Article | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      const foundArticle = articles.find(a => a.id === id);
      setArticle(foundArticle || null);
    }
  }, [id]);

  if (!article) {
    return (
      <div className="article-detail-page">
        <div className="article-detail-container article-not-found">
          <h1>Article Not Found</h1>
          <p>We couldn't find the article you were looking for.</p>
          <Link to="/articles" className="article-detail-back">
            Return to Articles
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="article-detail-page">
      <div className="article-detail-container">
        
        <div className="article-detail-header">
          <span className="article-detail-category">{article.category}</span>
          <h1 className="article-detail-title">{article.title}</h1>
          
          <div className="article-detail-meta">
            <span className="article-detail-author">By {article.author}</span>
            <span>•</span>
            <span>{article.date}</span>
          </div>
        </div>

        <div className="article-detail-hero">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#D1D5DB" strokeWidth="1.2"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 0-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/></svg>
        </div>

        <div 
          className="article-detail-content"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />

        <div className="article-detail-author-box">
          <div className="article-detail-author-avatar">
            {article.author.charAt(0)}
          </div>
          <div className="article-detail-author-info">
            <h4>{article.author}</h4>
            <p>
              Dedicated and versatile content writer with years of experience in creating clear, engaging, and well-researched content across multiple industries. Focuses strongly on audience needs and meaningful storytelling.
            </p>
          </div>
        </div>

        <Link to="/articles" className="article-detail-back">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to all articles
        </Link>
        
      </div>
    </div>
  );
};

export default ArticleDetail;
